import { PLC_LANGUAGES, PlcBrand, PlcLanguage } from '../types';

/**
 * The target-platform chip under each chat title in the sidebar, e.g.
 * "Siemens SCL" or "CODESYS ST".
 *
 * This used to be formatted independently by the browser (from PlcBrand) and by
 * the gateway (from the lowercase PlcVendor slug), and only the gateway's copy
 * was persisted — so signing back in swapped "CODESYS ST" for
 * "codesys Structured Text (SCL/ST)". Deriving the chip from the session config
 * keeps one format regardless of which side wrote the stored status string.
 *
 * Returns '' when the config cannot name a platform, so callers can fall back.
 */
export function formatSessionStatusLabel(
  config?: { brand?: string; language?: string } | null,
): string {
  const brand = config?.brand;
  const language = config?.language;
  if (!brand || !language || !Object.values(PlcBrand).includes(brand as PlcBrand)) {
    return '';
  }

  const brandShort = brand.split(' ')[0];
  const langShort = language === PlcLanguage.ST
    ? (brand === PlcBrand.Siemens ? 'SCL' : 'ST')
    : PLC_LANGUAGES.find(option => option.value === language)?.abbreviation
      || language.match(/\(([^)]+)\)/)?.[1] || language.split(' ')[0];

  return `${brandShort} ${langShort}`;
}
